import React from "react";
import { cn } from "../../lib/cn";

const baseStyles =
  "inline-flex items-center justify-center rounded-full font-semibold transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed";

const variantStyles = {
  primary:
    "bg-primary-600 text-white hover:bg-primary-500 focus-visible:ring-primary-500 shadow-soft",
  gradient:
    "bg-gradient-to-r from-primary-500 to-primary-600 text-white hover:from-primary-600 hover:to-primary-700 focus-visible:ring-primary-500 shadow-colored-primary hover:shadow-colored-primary-lg transition-all duration-300 hover:-translate-y-0.5",
  secondary:
    "bg-secondary-500 text-white hover:bg-secondary-400 focus-visible:ring-secondary-400 shadow-soft",
  outline:
    "border border-primary-200 text-primary-600 hover:bg-primary-50 focus-visible:ring-primary-500",
  ghost:
    "text-primary-600 hover:bg-primary-50 focus-visible:ring-primary-500",
  subtle:
    "bg-neutral-50 text-neutral-700 hover:bg-white border border-neutral-100 focus-visible:ring-neutral-300",
};

const sizeStyles = {
  sm: "h-9 px-4 text-sm",
  md: "h-11 px-5 text-sm",
  lg: "h-12 px-6 text-base",
};

export function Button({
  as: Component = "button",
  variant = "primary",
  size = "md",
  leftIcon,
  rightIcon,
  className,
  children,
  ...props
}) {
  return (
    <Component
      className={cn(
        baseStyles,
        variantStyles[variant] || variantStyles.primary,
        sizeStyles[size] || sizeStyles.md,
        className
      )}
      {...props}
    >
      {leftIcon && <span className="mr-2 inline-flex">{leftIcon}</span>}
      <span>{children}</span>
      {rightIcon && <span className="ml-2 inline-flex">{rightIcon}</span>}
    </Component>
  );
}


